import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, MapPin, ShieldCheck, Users, Star, Send } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-92">
      {/* Background with Gradient Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-93">
        <div className="absolute inset-0 bg-gradient-to-b from-cream via-cream/50 to-cream z-10" data-id="element-94" />
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-20" data-id="element-95" />

        {/* Decorative Elements */}
        <motion.div animate={{
        y: [0, -20, 0],
        opacity: [0.3, 0.6, 0.3]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-1/4 left-10 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-96" />
        <motion.div animate={{
        y: [0, 30, 0],
        opacity: [0.2, 0.5, 0.2]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute bottom-1/4 right-10 w-80 h-80 bg-forest/10 rounded-full blur-3xl" data-id="element-97" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-99">
          <span className="inline-block py-1 px-3 rounded-full bg-gold/10 text-gold-dark text-sm font-medium mb-6 border border-gold/20" data-id="element-100">
            Singapore's #1 Premium Spa Guide
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-forest mb-4 leading-tight" data-id="element-101">
            Discover Singapore's Finest <br data-id="element-102" />
            <span className="text-gold italic" data-id="element-103">Massage Experiences</span>
          </h1>
          <p className="text-xl md:text-2xl text-stone/80 mb-10 font-light tracking-wide" data-id="element-104">
            新加坡最值得信赖的专业按摩推荐平台
          </p>
        </motion.div>

        {/* Website Enter & Telegram Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-2xl mx-auto mb-16 flex flex-col sm:flex-row gap-4" data-id="element-105">
          <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" className="group flex-1 block bg-white p-5 rounded-2xl shadow-xl shadow-stone/10 border border-stone/5 hover:border-gold/30 hover:shadow-gold/10 transition-all duration-300" data-id="element-106">
            <div className="flex items-center gap-4" data-id="element-107">
              <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center shrink-0 group-hover:bg-gold/20 transition-colors" data-id="element-108">
                <ExternalLink className="text-gold" size={24} data-id="element-109" />
              </div>
              <div className="text-left" data-id="element-110">
                <span className="block text-forest font-serif font-bold text-lg group-hover:text-gold transition-colors" data-id="element-111">
                  Website Enter
                </span>
                <span className="block text-stone/70 text-sm" data-id="element-112">
                  中文网站入口
                </span>
              </div>
              <div className="ml-auto bg-forest group-hover:bg-gold text-white px-4 py-2.5 rounded-xl font-medium transition-colors duration-300 text-sm whitespace-nowrap" data-id="element-113">
                进入 →
              </div>
            </div>
          </a>

          <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="group flex-1 block bg-white p-5 rounded-2xl shadow-xl shadow-stone/10 border border-stone/5 hover:border-[#229ED9]/30 hover:shadow-[#229ED9]/10 transition-all duration-300" data-id="element-114">
            <div className="flex items-center gap-4" data-id="element-115">
              <div className="w-12 h-12 bg-[#229ED9]/10 rounded-full flex items-center justify-center shrink-0 group-hover:bg-[#229ED9]/20 transition-colors" data-id="element-116">
                <Send className="text-[#229ED9]" size={24} data-id="element-117" />
              </div>
              <div className="text-left" data-id="element-118">
                <span className="block text-forest font-serif font-bold text-lg group-hover:text-[#229ED9] transition-colors" data-id="element-119">
                  Telegram
                </span>
                <span className="block text-stone/70 text-sm" data-id="element-120">电报频道</span>
              </div>
              <div className="ml-auto bg-[#229ED9] group-hover:bg-[#1a8abf] text-white px-4 py-2.5 rounded-xl font-medium transition-colors duration-300 text-sm whitespace-nowrap" data-id="element-121">
                加入 →
              </div>
            </div>
          </a>
        </motion.div>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto border-t border-stone/10 pt-10" data-id="element-122">
          {[{
          icon: ShieldCheck,
          label: '100% Safe & Trusted',
          sub: 'Verified Partners'
        }, {
          icon: Users,
          label: '50,000+ Customers',
          sub: 'Happy Clients'
        }, {
          icon: Star,
          label: '8+ Years',
          sub: 'Excellence'
        }, {
          icon: MapPin,
          label: '500+ Shops',
          sub: 'Islandwide'
        }].map((item, index) => <div key={index} className="flex flex-col items-center" data-id="element-123">
              <item.icon className="text-gold mb-2" size={24} data-id="element-124" />
              <span className="font-serif font-bold text-forest text-lg" data-id="element-125">
                {item.label}
              </span>
              <span className="text-xs text-stone uppercase tracking-wider" data-id="element-126">
                {item.sub}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}